module.exports = __webpack_public_path__ + "static/media/App_Store_Badge.4a5e40df.svg";